export default __webpack_public_path__ + "assets/0281e63208bf26168a10a042361b9087.jpg";